export const DEAL_TYPES = {
    new_customer: 'New Customer',
    new_project_existing_customer: 'New Project – Existing Customer',
    expansion_upsell: 'Expansion / Upsell',
    renewal: 'Renewal',
    support_retainer: 'Support / Retainer',
    product_subscription_license: 'Product Subscription / License',
    product_development_partnership: 'Product Development Partnership',
    staff_augmentation: 'Staff Augmentation',
    strategic_partnership: 'Strategic / Partnership',
};

export const DEAL_TYPE_ORDER = Object.keys(DEAL_TYPES);

/** Legacy keys from earlier builds — display-friendly fallback */
const LEGACY_DEAL_TYPE_LABELS = {
    new_business: 'New Business',
    existing_business: 'Existing Business',
    upsell: 'Upsell',
};

export function getDealTypeLabel(key) {
    return DEAL_TYPES[key] || LEGACY_DEAL_TYPE_LABELS[key] || key;
}
